"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var dictateState = _ref.dictateState;
  return dictateState;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJkaWN0YXRlU3RhdGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VsZWN0b3JzL2RpY3RhdGVTdGF0ZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFJlZHV4U3RhdGUgfSBmcm9tICcuLi90eXBlcy9pbnRlcm5hbC9SZWR1eFN0YXRlJztcblxuZXhwb3J0IGRlZmF1bHQgKHsgZGljdGF0ZVN0YXRlIH06IFJlZHV4U3RhdGUpID0+IGRpY3RhdGVTdGF0ZTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztlQUVlO0VBQUEsSUFBR0EsWUFBSCxRQUFHQSxZQUFIO0VBQUEsT0FBa0NBLFlBQWxDO0FBQUEsQyJ9